module.exports = __webpack_public_path__ + "img/item-3-1.09b7f73f.png";